import React from "react";
import {
  Link,
} from "react-router-dom";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from 'query-string'

import Listx from "../../../../../components/listx";
import * as page from "../../../../../store/ducks/page.duck";

class List extends Listx {

  constructor(props) {
    super(props);

    this.currentPage = queryString.parse(props.location.search);

    this.headings = [
      { id: '#', label: '#' },
      { id: 'name', label: 'Department' },
      { id: 'description', label: 'Description', sort : false },
    ];
  }

  renderRowData(data){
    return [
      this.renderCell(data.name),
      this.renderCell(data.description),
      this.renderCell(
        <>
        <span className="pr-2">
        <Link to={'/hr/settings/departments/mg/'+data.id+'/positions'} className="btn btn-outline-brand btn-icon btn-xs" title="Manage Positions">
          <i className="flaticon2-group"></i>
        </Link>
        </span>
        {this.defaultActions(data.id)}
        </>
      , null, true),
    ];
  }

}

// Set default props
List.defaultProps = {
  canUpdate: true,
  canDelete: true,
  canCreate : true,
  CustomFilter : null,
};

const mapStateToProps = (state) => {
  return {
    module: state.page.module,
    redraw: state.page.reload,
  }
}

export default withRouter(connect(
  mapStateToProps,
  page.actions
)(List));